
import {
  computed,
  defineComponent,
  ref,
  watch,
} from 'vue';
import { useStore } from '@/store';
import { useRoute } from 'vue-router';
import useTogglePhoto from '@/composables/useTogglePhoto';
import useWindowSize from '@/composables/useWindowSize';
import SvgIcon from '@/components/SvgIcon.vue';
import PhotoCarousel from '../components/PhotoCarousel/PhotoCarousel.vue';
import CalendarBodyMonth from '../components/Calendar/CalendarBodyMonth.vue';

export default defineComponent({
  name: 'Calender',
  components: {
    PhotoCarousel,
    CalendarBodyMonth,
    SvgIcon,
  },
  props: {
    dateString: {
      type: String,
      default: () => '',
    },
  },
  setup(props) {
    const store = useStore();
    const route = useRoute();

    const setUpCalendar = () => {
      if (props.dateString !== '') {
        store.commit('setCurrentMonth', props.dateString);
      }
    };

    setUpCalendar();

    watch(
      () => props.dateString,
      () => {
        setUpCalendar();
      },
    );

    watch(
      () => route.name,
      () => {
        store.state.photosInCarousel = [];
      },
    );

    const { windowHeight } = useWindowSize();

    const { showPhotoInMobile, toggle } = useTogglePhoto();
    const buttonIcon = computed(() => {
      if (route.name === 'Calendar') {
        return showPhotoInMobile.value ? 'icon-calendar' : 'icon-photo';
      }
      return showPhotoInMobile.value ? 'icon-list' : 'icon-photo';
    });

    const rebuild = ref(true);
    const photos = computed(() => store.state.photosInCarousel);
    watch(
      () => photos.value,
      (oldVal, newVal) => {
        if (JSON.stringify(oldVal) !== JSON.stringify(newVal)) {
          rebuild.value = !rebuild.value;
        }
      },
    );

    return {
      windowHeight,
      showPhotoInMobile,
      toggle,
      buttonIcon,
      rebuild,
    };
  },
});
